import React from "react"
import { StackNavigationProp } from "@react-navigation/stack"
import { goBack, goToRoot, MainStackParamList } from "../../MainNavigation"
import { RouteProp } from "@react-navigation/native"
import Loading from "../../components/Loading"
import LockerAction from "../../components/LockerAction"
import { useDeliveryPickupCodeQuery } from "./queries.generated"
import { ErrorMessage } from "pusatec-react-native"

interface Props {
	navigation: StackNavigationProp<MainStackParamList, "PickupDelivery">
	route: RouteProp<MainStackParamList, "PickupDelivery">
}

export default function PickupDeliveryScreen(props: Props) {
	const { route, navigation } = props
	const { deliveryId } = route.params

	const { data, error, loading } = useDeliveryPickupCodeQuery({
		variables: { deliveryId },
		pollInterval: 2000,
	})
	const delivery = data?.delivery

	if (loading) return <Loading />
	if (error || !delivery) return <ErrorMessage extra={error} />
	return (
		<LockerAction
			code={delivery.pickupCode!}
			useCodeBefore={delivery.usePickupCodeBefore ?? null}
			codeUsedAt={delivery.pickupCodeUsedAt ?? null}
			onReportIssue={() => {
				navigation.push("ReportIssue", {
					situation: "DeliveryPickup",
					deliveryId: delivery.id,
				})
			}}
			onComplete={() => goToRoot(navigation)}
			onCancel={() => goBack(navigation)}
		/>
	)
}
